import {useMemo} from 'react';
import {getSupportedNetworks} from '@/utils/utils';

function useSortedSocialNetworks<T extends {provider: string}>(
  socialNetworks: T[],
  selectedPlatformProvider?: string
) {
  return useMemo(() => {
    const socialNetworkOrder = getSupportedNetworks();
    return socialNetworks.slice().sort((a, b) => {
      if (selectedPlatformProvider && selectedPlatformProvider !== 'all') {
        const aMatches = a.provider.includes(selectedPlatformProvider);
        const bMatches = b.provider.includes(selectedPlatformProvider);
        if (aMatches !== bMatches) return aMatches ? -1 : 1;
      }
      return (
        socialNetworkOrder.indexOf(a.provider) -
        socialNetworkOrder.indexOf(b.provider)
      );
    });
  }, [socialNetworks, selectedPlatformProvider]);
}

export default useSortedSocialNetworks;
